import { useTranslations } from "next-intl";
const UserDetails = ({
  session
}) => {
  const t = useTranslations("Common");
  return <>
      <p>{t("Hello")},</p>
      <p className="font-heading rtl:font-arabic text-xl font-medium">
        {session?.user?.name}
      </p>
    </>;
};
export default UserDetails;